export const GHOST_ICONS_LS_KEY_PREFIX = 'rovo-ghost-icons-';
